// extracted by css-extract-rspack-plugin
export default {"stock":"stock-djCZEm","selected":"selected-N0rU5m","targetGood":"targetGood-Cxwtyq","targetBad":"targetBad-VOISWl","errorIndicator":"errorIndicator-tYtjyO"};